import Button from "components/common/buttons/buttons";
import ForbidOrderTimeModal from "components/modals/KB/ForbidOrderTimeModal";
import { useKBGlobalState } from "contexts/KBContext";
import { useSession } from "next-auth/react";
import { useParams } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { sorRequest } from "utils/clientAPIs/kbAuth";
import { useIosFixedBottomButton } from "utils/ios";
import ObligationTermsNoti from "../../KB/ObligationTermsNoti";
import { KOREA } from "utils/constant/ITME_INFO";
import * as Sentry from "@sentry/react";
import { useKBOrder } from "lib/analytics/react/hooks/intent/kb/useKBOrder";
import { TrackedModalProvider } from "lib/analytics/react/modal";

function DetailTradeCTA({
  isMobile,
  isLoginUser,
  orderCategory,
  loc,
}: {
  isMobile: boolean;
  isLoginUser: boolean;
  orderCategory?: any;
  loc?: string;
}) {
  const router = useRouter();
  const kbOrder = useKBOrder();
  const [notAgreeObligationTerms, setNotAgreeObligationTerms] = useState(false);
  const [isObligationTermsModalOpen, setIsObligationTermsModalOpen] =
    useState(false);
  const { data: session }: any = useSession();
  // useIosFixedBottomButton();

  const { accounts, setKbAuth } = useKBGlobalState();
  const [cantTradeTimeModal, setCantTradeTimeModal] = useState<any>(false);
  const { ticker } = useParams();
  const clickHandler = (trType: "buy" | "sell") => {
    // 최선주문집행 약관에 동의하지 않은 경우 + 국내주식일때
    kbOrder.start({
      order_type: trType,
      ticker: ticker as string,
    });
    if (notAgreeObligationTerms && loc === KOREA) {
      setIsObligationTermsModalOpen(true);
      return;
    }

    //none-ko-holiday
    //none-ko-reserve
    //none-ko-end
    //none-us-holiday
    //none-us-day
    if (orderCategory?.type?.includes("none")) {
      setCantTradeTimeModal(orderCategory);
      return;
    }
    router.push(`/detail/${ticker}/kb/${trType}`);
  };

  const termsConfirmRequest = async () => {
    try {
      const result = await sorRequest(session?.user?.email, "GET", setKbAuth);
      const rgstDt = result?.rgstDt;
      if (!rgstDt) {
        Sentry.captureMessage(
          `[KB] ObligationTerms / ${session?.user?.email}`,
          {
            level: "error",
            tags: {
              errorType: `[KB] ObligationTerms`,
            },
            extra: { data: rgstDt },
          }
        );
        setNotAgreeObligationTerms(true);
      }
    } catch (error) {
      Sentry.captureMessage(`[KB] ObligationTerms / ${session?.user?.email}`, {
        level: "error",
        tags: {
          errorType: `[KB] ObligationTerms`,
        },
        extra: { data: error },
      });
      console.error(error);
    }
  };

  useEffect(() => {
    if (!session) return;
    if (
      !isLoginUser ||
      !isMobile ||
      !accounts?.length ||
      router.locale === "en"
    )
      return;
    termsConfirmRequest();
  }, [session]);

  if (!isLoginUser || !isMobile || !accounts?.length || router.locale === "en")
    return null;

  if (isObligationTermsModalOpen) {
    return (
      <div>
        <ObligationTermsNoti
          setIsObligationTermsModalOpen={setIsObligationTermsModalOpen}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <Button
        type="primary"
        clickHandler={() => {
          clickHandler("buy");
        }}
        size="md"
        text={"구매하기"}
        width="w-full"
        btnClass="!bg-red40 !px-2 !h-[42px]"
        data-gtm-id="sDetail-kb-buy-button"
      />
      <Button
        type="primary"
        clickHandler={() => {
          clickHandler("sell");
        }}
        size="md"
        text={"판매하기"}
        width="w-full"
        btnClass=" !px-2 !h-[42px]"
        data-gtm-id="sDetail-kb-sell-button"
      />

      <TrackedModalProvider
        modalId="stock_bs_unavailable_order_time"
        isOpen={cantTradeTimeModal}
      >
        {cantTradeTimeModal && (
          <ForbidOrderTimeModal
            setModalOpen={setCantTradeTimeModal}
            isModalOpen={cantTradeTimeModal}
          />
        )}
      </TrackedModalProvider>
    </div>
  );
}

export default DetailTradeCTA;
